<template>
    <div class="exchangeBox">
        <md-tab-bar
                v-model="current"
                :items="items"
        />

        <div class="exchangeContent" v-show="current == 1">
            <!--<div class="scrollBox">-->
                <div class="scrollY">
                    <div class="itemExchange"  v-for="(item, index) in ticketList" :key="index">
                        <div class="itemText" >
                            <div class="title-item"><span>电子券名称：{{item.coupons.title}}</span>
                                <span v-if="item.coupons.type == '001'" class="itemType">商场券</span>
                                <span v-if="item.coupons.type == '002'" class="itemType">品牌券</span>
                                <span v-if="item.coupons.type == '003'" class="itemType">停车券</span>
                            </div>
                            <div>兑换数量：{{item.exchangeNum}}</div>
                            <div>兑换时间：{{item.exchangeDate}}</div>
                        </div>
                    </div>

                </div>
            <!--</div>-->
        </div>
        <div class="exchangeContent" v-show="current == 2">
            <!--<div class="scrollBox">-->
               <div class="btnBox">
                    <div :class="['btn',{'btnActive':btnState}]" @click="showBtn1">未领取</div>
                    <div :class="['btn',{'btnActive':!btnState}]" @click="showBtn2">已领取</div>
               </div>
                <div class="tabTitle">
                    <div class="tabItem1">序号</div>
                    <div class="tabItem2">礼品</div>
                    <div class="tabItem3">积分</div>
                </div>
                <div class="giftScroll">
                    <div class="scrollY" v-if="btnState">
                        <div class="gifItem" v-for="(item, index) in giftList[1]" :key="index">
                            <div class="giftcItem1">{{item.giftSeq}}</div>
                            <div class="giftcItem2">{{item.giftName}}</div>
                            <div class="giftcItem3">{{item.score}}</div>
                        </div>

                    </div>
                    <div class="scrollY" v-else>
                        <div class="gifItem" v-for="(item, index) in giftList[0]" :key="index">
                            <div class="giftcItem1">{{item.giftSeq}}</div>
                            <div class="giftcItem2">{{item.giftName}}</div>
                            <div class="giftcItem3">{{item.score}}</div>
                        </div>
                    </div>

                </div>
            <!--</div>-->
        </div>
        <div class="exchangeContent" v-show="current == 3">
            <div class="tabTitle">
                <div class="tabItem1">订单号</div>
                <div class="tabItem1">时间</div>
                <div class="tabItem1">积分</div>
                <!--<div class="tabItem1">金额</div>-->
                <div class="tabItem1">类型</div>
            </div>
            <div class="scrollBox2">
                <div class="scrollY">
                    <!--<div class="integralBox">-->
                        <div class="integralItemBox" v-for="(item, index) in integralList" :key="index">
                            <div class="intItem">{{item.seqlSeq}}</div>
                            <div class="intItem">{{item.slTime}}</div>
                            <div :class="['intItem', {'se':item.state},{'se2':!item.state}]">{{item.vipscore}}</div>
                            <div class="intItem">{{item.consType}}</div>
                            <!--<div class="intItem">订单号</div>-->
                        </div>
                    <!--</div>-->
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "exchangeDetails",
        // computed:{
        //     dataList(){
        //         let arr = ''
        //         if(this.current == 1){
        //             arr = this.ticketList
        //         }else if(this.current == 2){
        //             if(this.btnState){
        //                 arr = this.giftList[1]
        //             }else{
        //                 arr = this.giftList[0]
        //             }
        //
        //         }else if(this.current == 3){
        //             arr = this.integralList
        //         }
        //
        //         return arr
        //     }
        // },
        data(){
          return {
              current: 1,
              items: [{name: 1, label: '换券记录'}, {name: 2, label: '换礼记录'},{name: 3, label: '积分记录'}],
              btnState:true, //控制领取按钮状态
              ticketList:[],//券
              giftList:[],//礼
              integralList:[], //积分
          }
        },
        created(){
            this.userData = JSON.parse(localStorage.getItem("userData"))
            let dt = new URLSearchParams()
            dt.append('openid', this.userData.wxOpenId)//换券
            dt.append('memberId', this.userData.id) //换券
            dt.append('cardNum', this.userData.cardAccount) //换礼
            dt.append('vipCardNum', this.userData.cardAccount) //积分
            this.$http.post('/sangto-wrm/vip/scoreLog/phonePage', dt).then(({data})=>{ //换礼记录

                this.giftList[0]=data.data.exchangeList
                this.giftList[1]= data.data.notChangeList
                //exchangeList 已领取
                //notChangeList 未领
            })
            this.$http.post('/sangto-wrm/vip/scoreLog/getRecordByMember', dt).then(({data})=>{ //换券记录

                let arr = [...data.data.rows]
                for(let i = 0; i<arr.length; i++){
                    if(!arr[i].scoreGift){
                        arr[i].coupons = JSON.parse(arr[i].coupons)
                        this.ticketList.push(arr[i])
                    }
                }


            })
            this.$http.post('/sangto-wrm/vip/member/getVipScoreInfoList', dt).then(({data})=>{ //积分记录


                let arr = data.data.scoreInfoList
                arr.forEach(item => {
                    item.slTime = this.dateNew(item.slTime)
                    if(item.vipscore >0){
                        item.state = true
                    }else{
                        item.state = false
                    }
                })
                this.integralList = arr
            })
        },
        mounted() {
            document.title = "兑换详情"

        },
        methods:{
            returnFn(){
                this.$router.go(-1)
            },
            showBtn1(){
                this.btnState = true
            },
            showBtn2(){
                this.btnState = false
            },
            dateNew(time){ //格式化时间
                let date = new Date(time)
                let y = date.getFullYear()
                let m = date.getMonth()+1
                let d = date.getDate()
                if(m <10){
                    m = '0'+m
                }
                if(d < 10){
                    d = '0'+d
                }
                return `${y}-${m}-${d}`
            }
            // getGiftFn(){//跳转领取礼品
            //     this.$router.push('/appMain/getGift')
            // },
            // getGiftDetailsFn(){ //领礼详情
            //     this.$router.push('/appMain/getGiftDetails')
            // },
            // gotoIntegralTicketDetailsFn(){//跳转积分换券记录详情
            //     this.$router.push('/appMain/integralTicketDetails')
            // }
        }
    }
</script>

<style lang="scss" scoped>
.exchangeBox{
    width: 100%;
    height: 100%;
    position: relative;
    .exchangeContent{
        position: absolute;
        top: 50px;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        /*display: flex;*/
        /*flex-direction: column;*/
        /*align-items: center;*/
        overflow-x: hidden;
        overflow-y: auto;
    }
    .se{
        color: #40d582;
    }
    .se2{
        color: #eb5d5b;
    }
    .intItem{
        flex: 1;
        text-align: center;
        line-height: 38px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .integralItemBox{
        width: 90%;
        font-size: 14px;
        display: flex;
        height: 38px;
        border-bottom: 1px solid #f1f1f1;
        color: #777;
    }
    .integralBox{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .itemType{
        margin-right: 8px;
        color: #444;
    }

    .giftcItem1{
        flex: 2;
        text-align: center;
        font-size: 14px;
        height: 38px;
        line-height: 38px;
        color: #5bbbff;
    }
    .giftcItem2{
        flex: 3;
        text-align: center;
        font-size: 14px;
        height: 38px;
        line-height: 38px;
        color: #46d5c6;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .giftcItem3{
        flex: 2;
        text-align: center;
        font-size: 14px;
        height: 38px;
        line-height: 38px;
        color: #f88a45;
    }


    .gifItem{
        height: 39px;
        line-height: 39px;
        width: 90%;
        display: flex;
        font-size: 14px;
        border-bottom: 1px solid #f1f1f1;
    }
    .tabItem1{
        flex: 2;
        text-align: center;
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        color: #333;
    }
    .tabItem2{
        flex: 3;
        text-align: center;
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        color: #333;
    }
    .tabItem3{
        flex: 2;
        text-align: center;
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        color: #333;
    }
    .tabTitle{
        width: 92%;
        display: flex;
        height: 20px;
        margin:14px auto 0 auto;
    }
    .scrollBox{
        position: absolute;
        top: 0px;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .scrollBox2{
        position: absolute;
        top: 45px;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        overflow-x: hidden;
        overflow-y: auto;

    }
    .itemExchange{
        width: 90%;
        height: 96px;
        border-bottom: 1px solid #dfdfdf;
        display: flex;
        align-items: center;
    }
    .imgBox{
        width: 84px;
        height: 72px;
        border: 1px solid #f1f1f1;
        margin-left: 2px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .itemText{
        flex: 1;
        height: 77px;
        margin-left: 10px;
        font-size: 14px;
        div{
            height: 24px;
            line-height: 24px;
            color: #888;
        }
        .title-item{
            height: 24px;
            line-height: 24px;
            margin-top: 5px;
            color: #333;
            display: flex;
            justify-content: space-between;
        }
    }
    .btnBox{
        margin: 12px auto 0 auto;
        width: 90%;
        border: 1px solid #dfdfdf;
        border-radius: 5px;
        height: 34px;
        display: flex;
    }
    .btn{
        line-height: 30px;
        text-align: center;
        flex: 1;
        font-size: 14px;
        color: #333;
    }
    .btnActive{
        background-color: #dfdfdf;
    }
    .giftScroll{
        position: absolute;
        top: 88px;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .scrollY{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .draw{
        position: absolute;
        right: 6%;
        background-color: #f80000;
        color: #fff;
        padding: 2px 6px 3px 6px;
        border-radius: 4px;
        font-size: 14px;
    }
}
</style>
